<template>
     <div class="daystopayserviceprovide-registration">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="daystopayserviceprovide-id" type="hidden" v-model="daystopayserviceprovide.id" />
             <b-row>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="IN:" 
                        label-for="daystopayserviceprovide-in_day_pay_service">
                        <b-form-input 
                            id="daystopayserviceprovide-in_day_pay_service" 
                            type="number" 
                            ref="searchFocus"
                            v-model="daystopayserviceprovide.in_day_pay_service" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            />
                    </b-form-group>
                </b-col>
                <b-col md="4" sm="12">
                    <b-form-group 
                        label="Unit:" 
                        label-for="daystopayserviceprovide-unit_day_pay_service">
                        <b-form-input 
                            id="daystopayserviceprovide-unit_day_pay_service" 
                            type="number" 
                            v-model="daystopayserviceprovide.unit_day_pay_service" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            />
                    </b-form-group>
                </b-col>  
               <b-col md="4" sm="12">
                    <b-form-group 
                        label="Day to Pay:" 
                        label-for="daystopayserviceprovide-day_for_pay_service">
                        <b-form-input 
                            id="daystopayserviceprovide-day_for_pay_service" 
                            type="number" 
                            v-model="daystopayserviceprovide.day_for_pay_service" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                             />
                    </b-form-group>
                </b-col>  

             </b-row>

         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Delete" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadParts(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="daystopayserviceprovides" 
                        :fields="fields">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadPart(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Delete" 
                            size="sm" 
                            variant="light" 
                            @click="loadPart(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-row>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
var moment = require('moment')

export default {
         name: 'DaysToPayServiceProvide',
            directives: {moment},
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                    daystopayserviceprovide: {},
                    daystopayserviceprovides: [],
                    showTable: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fields: [
                        { key: 'in_day_pay_service', label: 'In', sortable: true },
                        { key: 'unit_day_pay_service', label: 'Unit', sortable: true },
                        { key: 'day_for_pay_service', label: 'Day to Pay', sortable: true },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.daystopayserviceprovides.length
                }
            },
            methods: {
            formatDate (date) {
                return moment.utc(date).format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadParts() {
                const url = `${baseApiUrl}/daystopayserviceprovidesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.daystopayserviceprovides = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadParts()
            },
            alterModo() {
                        this.mode = 'save'
                        this.daystopayserviceprovide = {}
                        this.$refs.searchFocus.focus();
                },
            save() {

          
                    this.daystopayserviceprovide = {
                        ...this.daystopayserviceprovide,
                        company_id_pay_service: this.compan.id
                    }
                   
                const method = this.daystopayserviceprovide.id ? 'put' : 'post'
                const id = this.daystopayserviceprovide.id ? `/${this.daystopayserviceprovide.id}` : ''
                axios[method](`${baseApiUrl}/daystopayserviceprovides${id}`, this.daystopayserviceprovide)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.daystopayserviceprovide.id
                axios.delete(`${baseApiUrl}/daystopayserviceprovides/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadPart(daystopayserviceprovide, mode = 'save') {
                this.mode = mode
                this.daystopayserviceprovide = { ...daystopayserviceprovide }
            }
                
             },
            mounted() {
                this.showTable = true
                this.loadParts()
            }
    }       
</script>

<style>

     .daystopayserviceprovide-registration label {
        font-size: 0.75rem;
        color: black;
    }

    .daystopayserviceprovide-registration select{
        font-size: 0.75rem;
    }
    .daystopayserviceprovide-registration input{
        font-size: 0.75rem;
    }
    .daystopayserviceprovide-registration textarea{
        font-size: 0.75rem;
    }
    .daystopayserviceprovide-registration button{
        font-size: 0.75rem;
    }
    .daystopayserviceprovide-registration table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
